module.exports = __webpack_public_path__ + "img/zeitleiste-aufklappen-gruen2.d793a400.svg";